/* PRODUCT_PERFORMANCE */
export const GET_PRODUCT_PERFORMANCE = "GET_PRODUCT_PERFORMANCE"
export const GET_PRODUCT_PERFORMANCE_SUCCESS = "GET_PRODUCT_PERFORMANCE_SUCCESS"
export const GET_PRODUCT_PERFORMANCE_FAIL = "GET_PRODUCT_PERFORMANCE_FAIL"
